import axios from 'axios'
import { getToken } from '@/utils/auth'
import service, {tansParams} from "./request";
import { Message } from 'element-ui'
let Base64 = require('js-base64').Base64;

const mimeMap = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  // word: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=UTF-8',
  word: 'application/msword',
  zip: 'application/zip'
}

const baseUrl = process.env.VUE_APP_BASE_API
export function downLoadXlsx(str, data, filename) {
  var url = baseUrl + str
  axios({
    method: 'post',
    url: url,
    data: data,
    responseType: 'blob',
    headers: { 'Authorization': 'Bearer ' + getToken() }
  }).then(res => {
    resolveBlob(res, mimeMap.xlsx)
  })
}

export function downLoadWordPost(str, data) {
  var url = baseUrl + str
  axios({
    method: 'post',
    url: url,
    data: data,
    responseType: 'blob',
    headers: { 'Authorization': 'Bearer ' + getToken() }
  }).then(res => {
    resolveBlob(res, mimeMap.word)
  })
}

export function downLoadWord(str, data) {
  var url = baseUrl + str
  axios({
    method: 'get',
    url: url,
    data: data,
    responseType: 'blob',
    headers: { 'Authorization': 'Bearer ' + getToken() }
  }).then(res => {
    resolveBlob(res, mimeMap.word)
  })
}


export function downLoadZip(str, filename) {
  var url = baseUrl + str
  axios({
    method: 'get',
    url: url,
    responseType: 'blob',
    headers: { 'Authorization': 'Bearer ' + getToken() }
  }).then(res => {
    resolveBlob(res, mimeMap.zip)
  })
}
/**
 * 解析blob响应内容并下载
 * @param {*} res blob响应内容
 * @param {String} mimeType MIME类型
 */
export function resolveBlob(res, mimeType) {
  if (res.data.type === 'application/json') {
    const reader = new FileReader()  //创建一个FileReader实例
    reader.readAsText(res.data, 'utf-8') //读取文件,结果用字符串形式表示
    reader.onload = function() {//读取完成后,**获取reader.result**
      let { msg } = JSON.parse(reader.result)
      if (!msg) {
        msg = "执行出错"
      }
      Message({
        message: msg,
        type: 'error'
      })
    }
    return
  }
  const aLink = document.createElement('a')
  var blob = new Blob([res.data], { type: mimeType })
  // //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
  var patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
  var contentDisposition = decodeURI(res.headers['content-disposition'])
  var result = patt.exec(contentDisposition)
  var fileName = result[1]
  fileName = fileName.replace(/\"/g, '')
  aLink.href = URL.createObjectURL(blob)
  aLink.setAttribute('download', fileName) // 设置下载文件名称
  document.body.appendChild(aLink)
  aLink.click()
  document.body.removeChild(aLink);
}


// 通用下载方法
export function downloadExport(url, params, filename) {
  return service.post(url, params, {
    transformRequest: [(params) => {
      return tansParams(params)
    }],
    responseType: 'blob'
  }).then((data) => {
    const content = data
    const blob = new Blob([content])
    if ('download' in document.createElement('a')) {
      const elink = document.createElement('a')
      elink.download = filename
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    } else {
      navigator.msSaveBlob(blob, filename)
    }
  }).catch((r) => {
    console.error(r)
  })
}

// 下载public下静态资源 str:静态资源的文件名,filename: 实际输出的文件名
export function downLoadStaticFile(str, filename) {
  axios.get('/static/file/'+str, {
    responseType: 'blob', //重要
  }).then(response => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    if (!filename) {
      filename = str
    }
    link.href = url;
    link.setAttribute('download',filename);
    document.body.appendChild(link);
    link.click();
  }).catch(error => {
    console.log('error:'+JSON.stringify(error))
  });
}

export function ossDownload(objectName) {
  window.location.href = process.env.VUE_APP_BASE_API + "/system/File/downOssFileByPath?objectName=" + objectName;
}

// 预览服务的地址-用于文件预览
const VUE_APP_FILE_VIEW_SERVICE = 'http://25.211.152.49:8012/onlinePreview?url='
export function fileView(fileUrl){
  window.open(VUE_APP_FILE_VIEW_SERVICE+encodeURIComponent(Base64.encode(fileUrl)));
}
